export const TEMPLATE_LOCK_MODAL = {
  TEMPLATE_IS_EDITED_BY_LABEL: {
    key: 'TEMPLATE_IS_EDITED_BY_LABEL',
    value: 'This {{TemplateType}} is being edited',
  },
  READ_ONLY_MODE_LABEL: {
    key: 'READ_ONLY_MODE_LABEL',
    value: 'will be rendered in read only mode.',
  },
  EDITED_BY_NAME_LABEL: { key: 'EDITED_BY_NAME_LABEL', value: 'by' },
  TEMPLATE_LOCKED_TITLE: { key: 'TEMPLATE_LOCKED_TITLE', value: 'Template Locked' },
  ELEMENT_LOCKED_TITLE: { key: 'ELEMENT_LOCKED_TITLE', value: 'Element Locked' },
  LOCKED_MODAL_OK_BUTTON: { key: 'LOCKED_MODAL_OK_BUTTON', value: 'OK' },
  CURRENTLY_DESIGNING_MESSAGE: { key: 'CURRENTLY_DESIGNING_MESSAGE', value: 'The template is currently being designed by {{userName}}' },
  DELETE_RESTRICTION_MESSAGE: { key: 'DELETE_RESTRICTION_MESSAGE', value: 'Deletion of this template is restricted.' },
  RENDERED_READ_MODE_MESSAGE: { key: 'RENDERED_READ_MODE_MESSAGE', value: 'It will be rendered in read-only mode.' },
  STAY_BUTTON: { key: 'STAY_BUTTON', value: 'Stay' },
  INACTIVE_MESSAGE: { key: 'INACTIVE_MESSAGE', value: 'You were idle for last {{maxIdleTime}} minutes, Click stay to make changes or design will be closed in a minute.' },
};
